(function () {
  const TAG_PREFIX_DEFAULT = 'crew';
  const WORKER_DEFAULT = 'https://mariners-crew-apply.wade-a-barrie.workers.dev';

  function splitName(full) {
    const parts = String(full || '')
      .trim()
      .split(/\s+/)
      .filter(Boolean);
    if (parts.length === 0) return { first_name: '', last_name: '' };
    if (parts.length === 1) return { first_name: parts[0], last_name: '' };
    return {
      first_name: parts[0],
      last_name: parts.slice(1).join(' '),
    };
  }

  function readValue(form, selector) {
    const el = form.querySelector(selector);
    if (!el) return '';
    if (el.type === 'checkbox') return el.checked;
    return el.value;
  }

  function readAddress(form) {
    return {
      street: readValue(form, '[name="contact[Address street]"]'),
      line2: readValue(form, '[name="contact[Address line 2]"]'),
      city: readValue(form, '[name="contact[City]"]'),
      state: readValue(form, '[name="contact[State]"]'),
      zip: readValue(form, '[name="contact[Postal code]"]'),
      country: readValue(form, '[name="contact[Country]"]'),
    };
  }

  function formatAddress(address) {
    if (!address) return '';
    const streetLine = [address.street, address.line2].filter(Boolean).join(', ');
    const cityLine = [address.city, address.state, address.zip].filter(Boolean).join(', ');
    return [streetLine, cityLine, address.country].filter(Boolean).join('\n');
  }

  function buildPayload(form, tagPrefix, wrap) {
    const name = readValue(form, '[name="contact[Name]"]');
    const { first_name, last_name } = splitName(name);
    const skillsRaw = readValue(form, '[data-ms-crew-skills-output]');
    const skills = skillsRaw
      ? String(skillsRaw)
          .split(',')
          .map((s) => s.trim())
          .filter(Boolean)
      : [];

    const role = readValue(form, '[name="contact[Role]"]') || '';
    let specialty = readValue(form, '[name="contact[Specialty]"]');
    if (!specialty && role) specialty = role;

    const address = readAddress(form);

    return {
      email: readValue(form, '[name="contact[email]"]'),
      first_name,
      last_name,
      phone: readValue(form, '[name="contact[Phone]"]'),
      address,
      location: formatAddress(address),
      specialty,
      skills,
      team_preference: readValue(form, '[name="contact[Team preference]"]'),
      founders_circle: readValue(form, '[name="contact[Founders Circle]"]'),
      message: readValue(form, '[name="contact[Message]"]'),
      application:
        readValue(form, '[name="contact[Application]"]') || 'General crew interest',
      role,
      accepts_marketing: !!readValue(form, '[data-ms-crew-marketing]'),
      tag_prefix: tagPrefix || TAG_PREFIX_DEFAULT,
      notify_email: wrap?.dataset.msCrewNotifyEmail || '',
    };
  }

  function shopDomain(wrap) {
    return window.Shopify?.shop || wrap?.dataset.msCrewShop || '';
  }

  function resolveWorkerUrl(raw) {
    const url = String(raw || '').trim();
    if (/^https:\/\/[^/]+\.workers\.dev\/?$/i.test(url) || url.includes('.workers.dev')) {
      return url.replace(/\/$/, '');
    }
    return WORKER_DEFAULT;
  }

  /** Worker only — app proxy (/apps/crew-apply) is not used until Crew Apply proxy is verified. */
  function buildApiEndpoints(wrap) {
    const base = resolveWorkerUrl(wrap?.dataset.msCrewWorkerUrl) || WORKER_DEFAULT;
    return [proxyUrl(base, wrap), proxyUrl(WORKER_DEFAULT, wrap)].filter(
      (ep, i, arr) => arr.indexOf(ep) === i
    );
  }

  function proxyUrl(path, wrap) {
    const base = (path || '/apps/crew-apply').trim();
    const shop = shopDomain(wrap);

    if (base.startsWith('http://') || base.startsWith('https://')) {
      const url = new URL(base);
      if (shop && !url.searchParams.has('shop')) {
        url.searchParams.set('shop', shop);
      }
      return url.toString();
    }

    const normalized = base.startsWith('/') ? base : `/${base}`;
    if (!shop) return normalized;
    const joiner = normalized.includes('?') ? '&' : '?';
    return `${normalized}${joiner}shop=${encodeURIComponent(shop)}`;
  }

  function syncMarketingHidden(form, acceptsMarketing) {
    let field = form.querySelector('[name="contact[Marketing opt-in]"]');
    if (!field) {
      field = document.createElement('input');
      field.type = 'hidden';
      field.name = 'contact[Marketing opt-in]';
      form.appendChild(field);
    }
    field.value = acceptsMarketing ? 'yes' : 'no';
  }

  /** Shopify expects contact[body]; also used for the store inbox email. */
  function syncContactBody(form, payload) {
    let body = form.querySelector('[name="contact[body]"]');
    if (!body) {
      body = document.createElement('textarea');
      body.name = 'contact[body]';
      body.hidden = true;
      body.setAttribute('aria-hidden', 'true');
      form.appendChild(body);
    }
    const lines = [
      `Application: ${payload.application || 'General crew interest'}`,
      payload.role ? `Role: ${payload.role}` : null,
      payload.phone ? `Phone: ${payload.phone}` : null,
      payload.location ? `Address:\n${payload.location}` : null,
      payload.specialty ? `Specialty: ${payload.specialty}` : null,
      payload.skills?.length ? `Skills: ${payload.skills.join(', ')}` : null,
      payload.team_preference ? `Team: ${payload.team_preference}` : null,
      payload.founders_circle ? `Founders Circle: ${payload.founders_circle}` : null,
      `Marketing opt-in: ${payload.accepts_marketing ? 'yes' : 'no'}`,
      payload.message ? `\n${payload.message}` : null,
    ].filter((line) => line != null && line !== '');
    body.value = lines.join('\n').trim();
  }

  function revealSuccess(form) {
    const success = form.querySelector('[data-ms-crew-success]');
    const fields = form.querySelector('[data-ms-crew-fields]');
    if (success) {
      success.removeAttribute('hidden');
      success.scrollIntoView({ behavior: 'smooth', block: 'start' });
      success.focus?.({ preventScroll: true });
    }
    if (fields) fields.setAttribute('hidden', '');
    const submitBtn = form.querySelector('[type="submit"]');
    if (submitBtn) {
      submitBtn.disabled = true;
      const label = submitBtn.dataset.msSubmitLabel;
      if (label) submitBtn.textContent = label;
    }
  }

  function showSuccess(form, result) {
    if (result?.customer_id) {
      try {
        sessionStorage.setItem('ms_crew_last_customer_id', String(result.customer_id));
      } catch (e) {
        /* ignore */
      }
      console.info('Crew apply: customer saved', result.customer_id, result.tags_applied || result.tags);
    }
    revealSuccess(form);
  }

  function showError(form, message) {
    let box = form.querySelector('[data-ms-crew-client-error]');
    if (!box) {
      box = document.createElement('div');
      box.className = 'ms-crew-form__status ms-crew-form__status--error';
      box.setAttribute('data-ms-crew-client-error', '');
      box.setAttribute('role', 'alert');
      const fields = form.querySelector('[data-ms-crew-fields]');
      fields?.prepend(box);
    }
    box.textContent = message;
    box.hidden = false;
  }

  async function postCustomer(payload, endpoints) {
    const post = async (url) => {
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(payload),
      });
      const data = await res.json().catch(() => ({}));
      return { res, data, url };
    };

    let last = null;
    for (const endpoint of endpoints) {
      try {
        const attempt = await post(endpoint);
        last = attempt;
        if (attempt.res.ok && attempt.data.ok === true) {
          return attempt.data;
        }
      } catch (networkErr) {
        last = { res: { status: 0 }, data: {}, url: endpoint, networkErr };
      }
    }

    const { res, data, url, networkErr } = last || {
      res: { status: 0 },
      data: {},
      url: WORKER_DEFAULT,
    };
    if (networkErr) {
      throw new Error(
        'Could not reach the crew application service. Disable ad blockers for *.workers.dev and try again.'
      );
    }
    let msg = data.error || data.message || 'Could not save your application.';
    if (res.status === 404) {
      msg = `Application service not found (404). Expected Cloudflare Worker at ${WORKER_DEFAULT}`;
    }
    if (res.status === 402 || data.code === 'application_fee_required') {
      msg =
        data.error ||
        'Application fee required. Pay the fee or log in as a Founders Circle member, then try again.';
    }
    if (data.details) {
      const detail =
        typeof data.details === 'string' ? data.details : JSON.stringify(data.details);
      msg = `${msg} (${detail})`;
    }
    throw new Error(msg);
  }

  function bindCrewForm(form) {
    if (!form || form.dataset.msCrewFormBound === 'true') return;
    form.dataset.msCrewFormBound = 'true';

    const wrap = form.closest('[data-ms-crew-application-wrap]');
    const skillsOutput = form.querySelector('[data-ms-crew-skills-output]');
    const skillInputs = form.querySelectorAll('[data-ms-crew-skill]');
    const createCustomers = wrap?.dataset.msCrewCreateCustomers === 'true';
    const hasAccess = wrap?.dataset.msCrewAccess !== 'false';
    const apiEndpoints = buildApiEndpoints(wrap);

    const syncSkills = () => {
      if (!skillsOutput) return;
      const selected = Array.from(skillInputs)
        .filter((input) => input.checked)
        .map((input) => input.value.trim())
        .filter(Boolean);
      skillsOutput.value = selected.join(', ');
    };

    skillInputs.forEach((input) => {
      input.addEventListener('change', syncSkills);
    });

    const shouldIntercept = createCustomers && hasAccess && apiEndpoints.length > 0;
    if (shouldIntercept) {
      console.info('Crew apply: API endpoints', apiEndpoints);
    }

    let submitting = false;

    form.addEventListener('submit', async (event) => {
      syncSkills();

      if (!shouldIntercept) return;
      event.preventDefault();
      if (submitting) return;
      submitting = true;

      const submitBtn = form.querySelector('[type="submit"]');
      const prevLabel = submitBtn?.textContent;
      if (submitBtn) {
        if (!submitBtn.dataset.msSubmitLabel) {
          submitBtn.dataset.msSubmitLabel = submitBtn.textContent;
        }
        submitBtn.disabled = true;
        submitBtn.textContent = submitBtn.dataset.msLoadingLabel || 'Sending…';
      }

      const errBox = form.querySelector('[data-ms-crew-client-error]');
      if (errBox) errBox.hidden = true;

      try {
        const tagPrefix = wrap?.dataset.msCrewTagPrefix;
        const payload = buildPayload(form, tagPrefix, wrap);
        if (!payload.email) throw new Error('Email is required.');
        const specialtyField = form.querySelector('[name="contact[Specialty]"]');
        if (specialtyField && !payload.specialty) {
          throw new Error('Please select your specialty.');
        }

        syncMarketingHidden(form, payload.accepts_marketing);
        syncContactBody(form, payload);
        const result = await postCustomer(payload, apiEndpoints);
        if (window.msAnalytics?.trackCrewLead) {
          window.msAnalytics.trackCrewLead(payload);
        }
        showSuccess(form, result);
      } catch (err) {
        const message = err.message || 'Something went wrong. Please try again.';
        if (window.msAnalytics?.trackCrewError) {
          window.msAnalytics.trackCrewError(message);
        }
        showError(form, message);
        submitting = false;
        if (submitBtn) {
          submitBtn.disabled = false;
          if (prevLabel) submitBtn.textContent = prevLabel;
        }
      }
    });
  }

  function scrollToPostedSuccess(form) {
    if (form.hasAttribute('data-ms-crew-plain-form')) return;
    const success = form.querySelector('[data-ms-crew-success]');
    if (!success || success.hasAttribute('hidden')) return;
    revealSuccess(form);
  }

  async function recheckPaywallAccess(paywall) {
    const email = paywall.dataset.msCrewRecheckEmail;
    const workerUrl = resolveWorkerUrl(paywall.dataset.msCrewWorkerUrl);
    const shop = paywall.dataset.msCrewShop || window.Shopify?.shop || '';
    const statusEl = paywall.querySelector('[data-ms-crew-recheck-status]');
    const section = paywall.closest('.ms-crew-application');
    const wrap = section?.querySelector('[data-ms-crew-application-wrap]');

    if (!email || !workerUrl || !wrap) return;

    const url = new URL(workerUrl);
    url.searchParams.set('check', 'access');
    url.searchParams.set('email', email);
    if (shop) url.searchParams.set('shop', shop);

    try {
      const res = await fetch(url.toString(), {
        method: 'GET',
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });
      const data = await res.json().catch(() => ({}));
      if (data.granted) {
        paywall.hidden = true;
        wrap.classList.remove('ms-crew-application-wrap--pending');
        wrap.dataset.msCrewAccess = 'true';
        document.querySelectorAll('[data-ms-crew-fee-messaging]').forEach((el) => {
          el.hidden = true;
        });
        document.querySelectorAll('[data-ms-crew-ready-intro]').forEach((el) => {
          el.hidden = false;
        });
        document.querySelectorAll('[data-ms-crew-fee-applied-callout]').forEach((el) => {
          el.hidden = false;
        });
        if (statusEl) statusEl.textContent = 'Access confirmed — complete your application below.';
        if (window.msAnalytics?.trackCrewAccessGranted) {
          window.msAnalytics.trackCrewAccessGranted();
        }
        const form = wrap.querySelector('.ms-crew-form');
        if (form) bindCrewForm(form);
        return;
      }
      if (statusEl) {
        statusEl.textContent =
          'We still do not see a paid application fee or Founders Circle access on this account. Confirm the tag is on this email in Admin, or wait a minute after checkout and refresh.';
      }
    } catch (_err) {
      if (statusEl) {
        statusEl.textContent =
          'Could not verify your account automatically. Refresh the page, or log out and back in with the email that has the fee tag.';
      }
    }
  }

  function initAccessRecheck() {
    document.querySelectorAll('[data-ms-crew-access-recheck="true"]').forEach((paywall) => {
      recheckPaywallAccess(paywall);
    });
  }

  function init() {
    initAccessRecheck();

    document.querySelectorAll('[data-ms-crew-application-wrap] .ms-crew-form').forEach((form) => {
      const wrap = form.closest('[data-ms-crew-application-wrap]');
      if (wrap?.dataset.msCrewAccess === 'false') return;
      bindCrewForm(form);
      scrollToPostedSuccess(form);
    });

    if (window.location.search.includes('contact_posted=true')) {
      const hash = window.location.hash;
      if (hash) {
        document.querySelector(hash)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const form = event.target?.querySelector?.('[data-ms-crew-application-wrap] .ms-crew-form');
    if (form) bindCrewForm(form);
  });
})();
